import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { workoutPackAdd, workoutPackUpdate } from "../../../data/ApiEndpoints";
import SelectDropdown from "../../components-react/SelectDropdown";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { workoutPackagePlanAccess } from "../../common-data/DropdowData";
import {
  fetchWorkoutExperiencesData,
  fetchWorkoutGoalData,
} from "../../../redux/workout-reducers/workoutApis";
import SelectDropdownDynamic from "../../components-react/SelectDropdownDynamic";
import WorkoutCatCount from "./WorkoutCatCount";
import {
  validateWorkoutPackageForm,
  validateWorkoutPackageFormDays,
} from "../Datas";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import WorkoutDaysTab from "./workout-days/WorkoutDaysTab";

const WorkoutPackageForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
  isCopyPack,
  isViewOnly,
}) => {
  const dispatch = useDispatch();
  const { workoutGoals, workoutExperiences } = useSelector(
    (state) => state.workoutApi
  );
  const { loading } = useSelector((state) => state.common);

  const iniValues = {
    status: "active",
    limit: 10,
    page: 1,
    search: "",
  };
  const [fetchValues, setFetchValues] = useState(iniValues);
  const [totalPages, setTotalPages] = useState(1);

  const forminitials = {
    planName: isEdit && rowData?.plan_name ? rowData.plan_name : "",
    planDuration: isEdit && rowData?.plan_duration ? rowData.plan_duration : "",
    selPlanSuitableFor:
      isEdit && rowData?.plan_suitable_for && rowData?.plan_suitable_for_name
        ? {
            label: rowData.plan_suitable_for_name,
            value: rowData.plan_suitable_for,
          }
        : "",
    selPlanType:
      isEdit && rowData?.plan_type && rowData?.plan_type_name
        ? {
            label: rowData.plan_type_name,
            value: rowData.plan_type,
          }
        : "",
    selPlanCategory: "",
    selPlanAccess:
      isEdit && rowData?.plan_access
        ? {
            label: rowData.plan_access,
            value: rowData.plan_access,
          }
        : "",
    description: isEdit && rowData?.description ? rowData.description : "",
    isActive: isEdit && rowData.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const iniExDays = [
    {
      day: 1,
      allSetTypes: [
        {
          selSetType: "",
          allExercises: [
            {
              exerciseId: "1",
              selCategoryName: "",
              selExerciseName: "",
              restTime: "",
              sequenceNo: "",
              allSets: [
                {
                  setId: 1,
                  weight: "",
                  selTentativeDurationHH: "",
                  selTentativeDurationMM: "",
                  selTentativeDurationSS: "",
                  reps: "",
                },
              ],
            },
          ],
        },
      ],
    },
  ];
  const [exerciseDays, setExerciseDays] = useState(iniExDays);
  const [formErrors, setFormErrors] = useState({});
  const [formErrorsDays, setFormErrorsDays] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const uniqueExercises = getUniqueCategories(exerciseDays);

  const onChangeInput = (e) => {
    setIsSubmit(false);
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);

    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setFormErrors(validateWorkoutPackageForm(formValues, exerciseDays));
    setFormErrorsDays(validateWorkoutPackageFormDays(exerciseDays));
    setIsSubmit(true);
  };

  // ********-------------
  const handleSearchChange = (inputValue) => {
    setFetchValues((prev) => ({
      ...prev,
      page: 1,
      search: inputValue,
    }));
  };

  const fetchMoreData = () => {
    if (fetchValues.page + 1 <= totalPages) {
      setFetchValues((prev) => ({
        ...prev,
        page: prev.page + 1,
      }));
    }
  };

  const fetchPreviousData = () => {
    setFetchValues((prev) => ({
      ...prev,
      page: Math.max(prev.page - 1, 1),
    }));
  };
  // ------------------**********

  function getUniqueCategories(exerciseDays) {
    if (exerciseDays.length === 0) {
      return [];
    }

    const categoryMap = new Map();

    exerciseDays.forEach((day) => {
      day?.allSetTypes?.forEach((setType) => {
        setType?.allExercises?.forEach((exercise) => {
          const { selCategoryName } = exercise || {};

          if (selCategoryName) {
            const { value: category_id, label: category } =
              selCategoryName || {};
            if (category_id && category) {
              if (categoryMap.has(category_id)) {
                categoryMap.get(category_id).occurrences += 1;
              } else {
                categoryMap.set(category_id, {
                  name: category,
                  id: category_id,
                  occurrences: 1,
                });
              }
            }
          }
        });
      });
    });

    return Array.from(categoryMap.values());
  }

  function generateWorkoutDaysInfo1(exerciseDays) {
    const workoutDaysInfo = [];

    exerciseDays.forEach((day) => {
      const { day: day_no, allSetTypes = [] } = day;

      if (Array.isArray(allSetTypes)) {
        allSetTypes.forEach((setType, setTypeIndex) => {
          const { selSetType, allExercises = [] } = setType;
          const workout_type = selSetType?.value || "";

          if (Array.isArray(allExercises)) {
            allExercises.forEach((exercise, exerciseIndex) => {
              const {
                exerciseId,
                selExerciseName,
                restTime = "",
                sequenceNo = 0,
                allSets = [],
              } = exercise;
              const { value: exercise_id } = selExerciseName || {};

              const group_id = setTypeIndex + 1;

              const exerciseInfo = {
                day_no: day_no.toString(),
                workout_type,
                exercise_no: exerciseId.toString(),
                exercise_id,
                rest_time: restTime.toString(),
                ex_seq: sequenceNo,
                group_id,
                sets: [],
              };

              if (Array.isArray(allSets)) {
                allSets.forEach((set) => {
                  const { weight = "", reps = "" } = set;
                  exerciseInfo.sets.push({
                    weight: weight.toString(),
                    reps: reps.toString(),
                  });
                });
              }

              workoutDaysInfo.push(exerciseInfo);
            });
          }
        });
      }
    });

    return workoutDaysInfo;
  }
  function generateWorkoutDaysInfo(exerciseDays) {
    const workoutDaysInfo = [];

    exerciseDays.forEach((day) => {
      const { day: day_no, allSetTypes = [] } = day;

      if (Array.isArray(allSetTypes)) {
        allSetTypes.forEach((setType, setTypeIndex) => {
          const { selSetType, allExercises = [] } = setType;
          const workout_type = selSetType?.value || "";

          if (Array.isArray(allExercises)) {
            allExercises.forEach((exercise, exerciseIndex) => {
              const {
                exerciseId,
                selExerciseName,
                restTime = "",
                sequenceNo = 0,
                allSets = [],
              } = exercise;
              const { value: exercise_id } = selExerciseName || {};

              const group_id = setTypeIndex + 1;

              const exerciseInfo = {
                day_no: day_no.toString(),
                workout_type,
                exercise_no: exerciseId.toString(),
                exercise_id,
                rest_time: restTime.toString(),
                ex_seq: sequenceNo,
                group_id,
                sets: [],
              };

              if (Array.isArray(allSets)) {
                allSets.forEach((set) => {
                  const {
                    weight = "",
                    reps = "",
                    selTentativeDurationHH = { value: "00" },
                    selTentativeDurationMM = { value: "00" },
                    selTentativeDurationSS = { value: "00" },
                  } = set;

                  const duration = `${selTentativeDurationHH?.value || "00"}:${
                    selTentativeDurationMM?.value || "00"
                  }:${selTentativeDurationSS?.value || "00"}`;

                  exerciseInfo.sets.push({
                    weight: weight?.toString(),
                    reps: reps?.toString(),
                    duration,
                  });
                });
              }

              workoutDaysInfo.push(exerciseInfo);
            });
          }
        });
      }
    });

    return workoutDaysInfo;
  }

  function getWorkoutPlans(filters) {
    dispatch(
      fetchWorkoutGoalData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutWorkoutSuitableFor() {
    const filters = {
      status: "active",
    };

    dispatch(
      fetchWorkoutExperiencesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAddLead = async (payload) => {
    const method = isEdit && !isCopyPack ? "PUT" : "POST";
    const endpoint = isEdit && !isCopyPack ? workoutPackUpdate : workoutPackAdd;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      planName: isEdit && rowData?.plan_name ? rowData.plan_name : "",
      planDuration:
        isEdit && rowData?.plan_duration ? rowData.plan_duration : "",
      selPlanSuitableFor:
        isEdit && rowData?.plan_suitable_for && rowData?.plan_suitable_for_name
          ? {
              label: rowData.plan_suitable_for_name,
              value: rowData.plan_suitable_for,
            }
          : "",
      selPlanType:
        isEdit && rowData?.plan_type && rowData?.plan_type_name
          ? {
              label: rowData.plan_type_name,
              value: rowData.plan_type,
            }
          : "",
      selPlanAccess:
        isEdit && rowData?.plan_access
          ? {
              label: rowData.plan_access,
              value: rowData.plan_access,
            }
          : "",
      description: isEdit && rowData?.description ? rowData.description : "",
      isActive: isEdit && rowData.status === "active" ? true : false,
    }));
  }, []);

  useEffect(() => {
    if (isEdit && rowData?.workout_days_info?.length > 0) {
      const transformedData = rowData.workout_days_info.reduce(
        (acc, dayInfo) => {
          const { day_no, all_sets } = dayInfo;

          let dayObj = acc.find((day) => day.day === parseInt(day_no));
          if (!dayObj) {
            dayObj = {
              day: parseInt(day_no),
              allSetTypes: [],
            };
            acc.push(dayObj);
          }

          const allSetTypes = (all_sets || []).map((setInfo) => {
            const { workout_type, all_exercises } = setInfo;

            return {
              selSetType: workout_type
                ? {
                    value: workout_type,
                    label:
                      workout_type.charAt(0).toUpperCase() +
                      workout_type.slice(1),
                  }
                : "",
              allExercises: (all_exercises || []).map((exercise) => {
                const {
                  exercise_no,
                  exercise_id,
                  exercise_id_name,
                  rest_time,
                  ex_seq,
                  sets,
                  category,
                  category_name,
                  workout_mode,
                } = exercise;

                return {
                  exerciseId: exercise_no || "",
                  selCategoryName:
                    category_name && category
                      ? {
                          label: category_name,
                          value: category,
                        }
                      : "",
                  selExerciseName:
                    exercise_id && exercise_id_name
                      ? {
                          value: exercise_id,
                          label: exercise_id_name,
                          info: {
                            category: category_name,
                            category_id: category,
                            workout_mode: workout_mode,
                          },
                        }
                      : "",
                  restTime: rest_time || "",
                  sequenceNo: ex_seq || "",
                  allSets: (sets || []).map((set, index) => {
                    const [hh, mm, ss] = set?.duration?.trim()?.split(":") || [
                      "",
                      "",
                      "",
                    ];

                    return {
                      setId: index + 1,
                      weight: set.weight || "",
                      reps: set.reps || "",
                      selTentativeDurationHH: {
                        label: hh,
                        value: hh,
                      },
                      selTentativeDurationMM: {
                        label: mm,
                        value: mm,
                      },
                      selTentativeDurationSS: {
                        label: ss,
                        value: ss,
                      },
                    };
                  }),
                };
              }),
            };
          });

          // Assign set types to the day object
          dayObj.allSetTypes = allSetTypes;

          return acc;
        },
        []
      );

      setExerciseDays(transformedData);
    }
  }, [isEdit, rowData]);

  // LOGIC TO CREATE NO. OF DAY TABS ACCORDING TO THE  planDuration
  useEffect(() => {
    if (formValues.planDuration) {
      const endDay = parseInt(formValues.planDuration, 10) || 0;

      setExerciseDays((prevDays = []) => {
        const newExerciseDays = [...prevDays];

        for (let i = newExerciseDays.length + 1; i <= endDay; i++) {
          newExerciseDays.push({
            day: i,
            allSetTypes: [
              {
                selSetType: "",
                allExercises: [
                  {
                    exerciseId: "1",
                    selCategoryName: "",
                    selExerciseName: "",
                    restTime: "",
                    sequenceNo: "",
                    allSets: [
                      {
                        setId: 1,
                        weight: "",
                        selTentativeDurationHH: "",
                        selTentativeDurationMM: "",
                        selTentativeDurationSS: "",
                        reps: "",
                      },
                    ],
                  },
                ],
              },
            ],
          });
        }

        if (newExerciseDays.length > endDay) {
          newExerciseDays.length = endDay;
        }

        return newExerciseDays;
      });
    }
  }, [formValues.planDuration]);
  // -----------------------  LOGIC TO CREATE NO. OF DAY TABS ACCORDING TO THE  planDuration  -----------------------

  useEffect(() => {
    setFormErrorsDays(validateWorkoutPackageFormDays(exerciseDays));
  }, [exerciseDays]);

  useEffect(() => {
    if (workoutGoals?.pagination?.length > 0) {
      setTotalPages(workoutGoals?.pagination?.[0]?.pagination || 1);
    } else {
      setTotalPages(1);
    }
  }, [workoutGoals]);

  useEffect(() => {
    getWorkoutWorkoutSuitableFor();
  }, []);

  useEffect(() => {
    getWorkoutPlans(fetchValues);
  }, [fetchValues]);

  useEffect(() => {
    if (formErrorsDays?.exerciseDays?.length > 0) {
      setIsFormDisabled(true);
    } else {
      setIsFormDisabled(false);
    }
  }, [formErrorsDays]);

  useEffect(() => {
    if (isFormDisabled) {
      setFormValues((prevs) => ({
        ...prevs,
        isActive: false,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        isActive:
          (isEdit && rowData.status === "active") || !isFormDisabled
            ? true
            : false,
      }));
    }
  }, [isFormDisabled]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const workout_days_info = generateWorkoutDaysInfo(exerciseDays);

      const userData = {
        plan_name: formValues.planName || "",
        plan_duration: formValues.planDuration || "",
        plan_suitable_for: formValues.selPlanSuitableFor?.value || "",
        plan_type: formValues.selPlanType?.value || "",
        package_for: "gym",
        plan_access: formValues.selPlanAccess?.value || "",
        description: formValues.description || "",
        workout_focus_stats: uniqueExercises.map((exercise) => ({
          exercise_muscle_category: exercise.id,
          total_exercise: exercise.occurrences.toString(),
        })),
        workout_days_info: workout_days_info,
        status: isFormDisabled
          ? "inactive"
          : formValues.isActive
          ? "active"
          : "inactive",
      };

      if (isEdit && !isCopyPack) {
        userData.uid = rowData.uid;
      }

      // console.log("userData=> ", userData);

      const handleConfirm = async () => {
        handleAddLead(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${
          isFormDisabled || formErrorsDays?.exerciseDay
            ? "If all form inputs are not filled, submission is possible but the form will remain inactive until all fields are completed."
            : "Are you sure!"
        }`,
        "Edit Form",
        `${isEdit && !isCopyPack ? "Update" : "Add"} Workout Package`
      );
    }
  }, [isSubmit, formErrors, isFormDisabled]);

  console.log("formErrors=> ", formErrors);
  console.log("formErrorsDays=> ", formErrorsDays);

  return (
    <div className="createNewCTOModalContainer mealsModalContainer">
      {!isViewOnly && (
        <CommonHeadingNBtns
          title={`${
            isEdit && !isCopyPack ? "Update" : isCopyPack ? "Copy" : "Create"
          } Workout Package`}
          onClose={closeModal}
          onClick={onSubmit}
          isLoading={loading}
        />
      )}

      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="planName" className={`formInputLabel `}>
              Workout Package name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Workout Package name"
              className={`formInput ${formErrors?.planName ? "formError" : ""}`}
              name="planName"
              value={formValues.planName}
              onChange={onChangeInput}
              disabled={isViewOnly}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="planDuration" className={`formInputLabel `}>
              Workout Package duration <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter no of days"
              className={`formInput ${
                formErrors?.planDuration ? "formError" : ""
              }`}
              name="planDuration"
              value={formValues.planDuration}
              onChange={onChangeInput}
              min={1}
              disabled={isViewOnly}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selPlanSuitableFor" className="formInputLabel">
              Workout Package suitable for <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selPlanSuitableFor ? "formError" : ""
              }`}>
              <SelectDropdown
                options={workoutExperiences?.dropdown || []}
                selectedOption={formValues.selPlanSuitableFor}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selPlanSuitableFor")
                }
                name="from the list"
                preventKeyboardOpen={false}
                isDisable={isViewOnly}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="selPlanType"
              className={`formInputLabel ${
                formErrors?.selPlanType && "formError"
              }`}>
              Workout Package type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selPlanType && "formError"
              }`}>
              <SelectDropdownDynamic
                options={workoutGoals?.dropdown || []}
                selectedOption={formValues.selPlanType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selPlanType")
                }
                name="from the list"
                preventKeyboardOpen={false}
                onSearchChange={handleSearchChange}
                fetchMoreData={fetchMoreData}
                fetchPreviousData={fetchPreviousData}
                isDisable={isViewOnly}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selPlanAccess" className="formInputLabel">
              Workout Package access <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selPlanAccess && "formError"
              }`}>
              <SelectDropdown
                options={workoutPackagePlanAccess}
                selectedOption={formValues.selPlanAccess}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selPlanAccess")
                }
                name="from the list"
                preventKeyboardOpen={true}
                isDisable={isViewOnly}
              />
            </div>
          </div>

          <div className="formInputBox span4">
            <label htmlFor="description" className="formInputLabel">
              description <span className="required">*</span>
            </label>

            <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
              <ReactQuill
                id="description"
                name="description"
                className={`formInput ${
                  formErrors?.description ? "formError" : ""
                }`}
                placeholder="Enter description.."
                value={formValues.description}
                onChange={(content) =>
                  onChangeTextInput(content, "description")
                }
                readOnly={isViewOnly}
              />
            </div>
          </div>
        </div>

        {uniqueExercises?.length > 0 ? (
          <WorkoutCatCount uniqueExercises={uniqueExercises} />
        ) : null}

        {formValues.planDuration ? (
          <WorkoutDaysTab
            userInfoData={userInfoData}
            exerciseDays={exerciseDays}
            setExerciseDays={setExerciseDays}
            formErrors={formErrorsDays}
            setIsSubmit={setIsSubmit}
            isViewOnly={isViewOnly}
          />
        ) : null}

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}>
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
                disabled={isFormDisabled || isViewOnly}
                style={{
                  cursor: isFormDisabled ? "not-allowed" : "pointer",
                }}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default WorkoutPackageForm;
